;(function() {
/* @ngInject */
function CustomObjednaneController(CompletedOrderService, $window) {
    let vm = this;
    let server = CompletedOrderService;

    vm.payment = "movement";
    vm.showMovement = false;

    server.getCompletedOrderData().then(onOrderDataLoad);

    function onOrderDataLoad(payment) {
        if(payment) {
            vm.orderId = payment.orderId;
            vm.price = payment.price;
            vm.paymentData = payment;
            vm.invoiceHref = `/invoice/download?orderId=${payment.orderId}`;
            vm.proformaHref = `/invoice/download?proforma=true&orderId=${payment.orderId}`;
            vm.documentsHref = `/objednavka/detail?o=${payment.documentsLink}`;
        } else {
            $window.location = "/";
        }
    }
}

angular.module("firmaren")
    .controller("CustomObjednaneController", CustomObjednaneController);
}());
